import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';

import { EcmMaterialModule } from '@ecm/material';
import { EcmRouterModule, Link, LinkService, TrackingData } from '@ecm/router';

import { SharedService } from '../../../business/api/dashboardV7/sharedService';
import { SharedServiceEnum } from '../../../business/api/dashboardV7/sharedServicesEnum';
import { TrackedPage } from '../../../business/model/tracking/trackedPage.enum';
import { BreakpointService } from '../../../services/breakpoint.service';

@Component({
    selector: 'sharedservices',
    templateUrl: 'shared-services.component.html',
    styleUrls: ['shared-services.component.css'],
    standalone: true,
    imports: [EcmMaterialModule, EcmRouterModule, TranslateModule, NgTemplateOutlet, NgClass],
})
export class SharedServicesComponent {
    @Input()
    public viewModels: SharedService[];
    @Input()
    public isNsru: boolean;

    private readonly _breakpointService: BreakpointService = inject(BreakpointService);
    protected readonly linkService: LinkService = inject(LinkService);

    // max-width < 735px
    public isMobileWidth = toSignal(this._breakpointService.isMobileWidth());
    // (max-width > 1200px)
    public isLargeWidth = toSignal(this._breakpointService.isLargeWidth());

    public openLink(link: Link, type: SharedServiceEnum) {
        const trackedPage = TrackedPage.dashboard;
        let trackingName = '';
        let trackingArea = '';
        if (this.isNsru) {
            trackingArea = 'care_hp_services_partages_nsru';
            trackingName =
                type === SharedServiceEnum.shareAntiSpamAppels
                    ? 'services_partages_orange_anti_spam_appel_nsru'
                    : 'services_partages_tv_orange_nsru';
        } else {
            trackingArea = 'care_hp_services_partages_titulaire';
            trackingName =
                type === SharedServiceEnum.shareAntiSpamAppels
                    ? 'services_partages_orange_anti_spam_appel_titualire'
                    : 'services_partages_tv_orange_titualire';
        }
        this.linkService.openLink(
            link,
            Object.assign(new TrackingData(), {
                tmsTracking: {
                    trackedPage: trackedPage,
                    trackingArea: trackingArea,
                    trackingName: trackingName,
                },
            }),
        );
    }
}
